import styles from "./ArticleLockup.module.scss";
const ArticleLockup = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.root}>{children}</div>;
};

export default ArticleLockup;
